/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react';
import { Flex, Text, Button, Box } from '@chakra-ui/react';
import axios from 'axios';
import { AddIcon } from '@chakra-ui/icons';
import { WarehouseView } from '../WarehouseView/WarehouseView.components';
import { factoryTableQuantitatives } from '../../../../factory/factoryTableQuantitatives';
import { Quantitatives } from '../../../../services/protocols';
import { useQuantitatives } from '../../../../contexts/QuantitativesContext';
import { Logo } from '../../../Logo/Logo';
import { TableQuantitatives } from '../TableQuantitatives/TableQuantitatives.components';
import { CheckCircleAlertIcon, WarningAlertIcon, WarningCircleAlertIcon } from '../../../Icons';
import { defaultStateAlertModal } from '../../../../contexts/QuantitativeContext.types';
import { PremisesModal } from '../../../Premises/Premises.component';
import { Info } from '@phosphor-icons/react';

interface GenerateQuantitativesProps {
  data: Quantitatives;
}

export function GenerateQuantitatives({ data }: GenerateQuantitativesProps) {
  const { setAlertModalIsOpen, setIsModalOpen, isModalOpen } = useQuantitatives();

  const factoryDataTable = factoryTableQuantitatives(data);

  const [downloadSuccess, setDownloadSuccess] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [premisesOpen, setPremisesOpen] = useState(false);

  useEffect(() => {
    if (downloadProgress > 0 && downloadProgress < 100) {
      setAlertModalIsOpen(defaultStateAlertModal);
    }

    if (downloadSuccess === true) {
      setAlertModalIsOpen({
        open: true,
        icon: CheckCircleAlertIcon,
        title: 'Exportação concluída',
        description: 'Sua planilha foi exportada com sucesso e está pronta para ser acessada.',
        textSubmit: '',
        textCancel: 'Fechar',
        submitDangerous: false,
        onSubmit: () => {},
      });
    }
  }, [downloadProgress, downloadSuccess]);

  const downloadFile = async (url: string) => {
    try {
      await axios.get(url, {
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setDownloadProgress(percentCompleted);
        },
      });

      const fileName = url.split('/').pop();
      const aTag = document.createElement('a');
      aTag.href = url;
      if (fileName) {
        aTag.setAttribute('download', fileName);
      }
      document.body.appendChild(aTag);
      aTag.click();
      document.body.removeChild(aTag);
      setDownloadSuccess(true);
      setIsModalOpen({ open: null, isExported: true });
    } catch (error) {
      console.error('Error downloading file:', error);
      setAlertModalIsOpen({
        open: true,
        icon: WarningCircleAlertIcon,
        title: 'Não conseguimos exportar sua planilha',
        description: 'Erro inesperado. Entre em contato com o suporte.',
        textSubmit: '',
        textCancel: 'Fechar',
        submitDangerous: false,
        onSubmit: () => {},
      });
    }
  };

  const handleExport = () => {
    setAlertModalIsOpen({
      open: true,
      icon: WarningAlertIcon,
      title: 'Deseja exportar sua planilha?',
      description: 'A planilha será exportada automaticamente após confirmação.',
      textSubmit: 'Continuar',
      textCancel: 'Voltar',
      submitDangerous: false,
      loader: false,
      onSubmit: () => {
        downloadFile(data?.download_link);
      },
    });
  };

  const handleNewQuantitativo = () => {
    if (!isModalOpen.isExported) {
      setAlertModalIsOpen({
        open: true,
        icon: WarningAlertIcon,
        title: 'Planilha não exportada',
        description:
          'Ao gerar um novo quantitativo, as inforamções atuais serão perdidas. Considere exportar a planilha.',
        textSubmit: 'Continuar',
        textCancel: 'Voltar',
        submitDangerous: false,
        loader: false,
        onSubmit: () => {
          setIsModalOpen({ open: 'GeneralInfo' });
        },
      });
    } else {
      setIsModalOpen({ open: 'GeneralInfo' });
    }
  };

  return (
    <>
      <Flex bg="#f8f8f8" gap="32px" paddingRight="48px" minHeight="100%" width={'100%'}  overflow={'auto'}>
        <Flex flexDir="column" w="fit-conent" bg="#fff" p="44px 20px 0 24px">
          <Box w="192px">
            <Logo />
          </Box>
          <Button
            display="flex"
            variant="primary"
            fontSize="16px"
            fontWeight="600"
            alignItems="center"
            leftIcon={<AddIcon boxSize={4} />}
            onClick={handleNewQuantitativo}
            marginTop={'44px'}
          >
            Novo quantitativo
          </Button>
          <Button
            display="flex"
            variant="primary"
            width={'100%'}
            bgColor="#EBF8FF"
            fontSize="16px"
            justifyContent="flex-start"
            fontWeight="600"
            alignItems="center"
            leftIcon={<Info size="24px" />}
            onClick={() => {
              setPremisesOpen(true);
            }}
            marginTop={'24px'}
          >
            Premissas
          </Button>
        </Flex>
        <Flex w="100%" flexDirection="column" mt="44px" gap="44px">
          <Flex justifyContent="space-between">
            <Text color="#2D3748" fontSize="24px" fontWeight="700">
              Quantitativos gerados
            </Text>
            <Button
              variant="quaternary"
              onClick={() => handleExport()}
              isDisabled={!data?.download_link}
            >
              Exportar Planilha
            </Button>
          </Flex>
          <Flex
            bgColor="white"
            padding="1rem"
            flexDir="column"
            gap="1rem"
            borderRadius="1rem"
            backgroundColor="#fff"
          >
            <TableQuantitatives data={factoryDataTable} />
            <Text
              fontSize="10px"
              color="#667085"
              alignSelf="flex-end"
              letterSpacing="1px"
              mb="1rem"
            >
              * A taxa de ligações entre os elementos não está inclusa.
            </Text>
            <WarehouseView />
          </Flex>
        </Flex>
      </Flex>
      {premisesOpen && (
        <PremisesModal isOpen={premisesOpen} onClose={() => setPremisesOpen(false)} />
      )}
    </>
  );
}
